import { NodeApi, NodeRendererProps } from "react-arborist";
import { Data } from "./types";
import { ArrowRight, ArrowUp, FileText, FolderIcon } from "lucide-react";
import { ContextMenu, ContextMenuContent, ContextMenuItem, ContextMenuTrigger } from "@/components/ui/context-menu";
import clsx from "clsx";
import styles from "../../../../forms/styles/tree.module.css";
import { INDENT_STEP } from "./constants";
import { Input } from "@/components/ui/input";
import React from "react";
import { useTranslations } from "use-intl";
type TreeNodeProps = {
  handleAddGroupInsideNode: (node: NodeApi<Data>) => void;
  onRemoveFolder: (node: NodeApi<Data>) => void;
  openRegistratureAddDialog: () => void;
  viewOnly?: boolean;
  treeRef?: React.RefObject<HTMLDivElement>;
};
const Node = ({
  handleAddGroupInsideNode,
  openRegistratureAddDialog,
  onRemoveFolder,
  viewOnly = false,
  treeRef
}: TreeNodeProps) => function NodeInner({
  node,
  style,
  dragHandle
}: NodeRendererProps<Data>) {
  const t = useTranslations();
  console.log("node", node);
  const getNodeIcon = () => {
    switch (node.data.type) {
      case "registrature":
        return FileText;
      case "group":
        return FolderIcon;
    }
  };
  const Icon = getNodeIcon();
  const indentSize = Number.parseFloat(`${style.paddingLeft || 0}`);
  const editButton = () => {
    return <ContextMenuItem onClick={() => node.edit()} data-sentry-element="ContextMenuItem" data-sentry-component="editButton" data-sentry-source-file="TreeNode.tsx">
          {t("src_app_dashboard_admin_institutions_id_official_monitor_components_TreeNode_tsx_0")}
        </ContextMenuItem>;
  };
  return <>
        {node.data.type === "group" ? <ContextMenu>
            <ContextMenuTrigger disabled={viewOnly}>
              <div ref={dragHandle} style={style} className={clsx(styles.node, node.state)} onClick={() => node.isInternal && node.toggle()}>
                <div className={styles.indentLines}>
                  {new Array(indentSize / INDENT_STEP).fill(0).map((_, index) => {
              return <div key={index}></div>;
            })}
                </div>
                <FolderArrow node={node} />
                {node.isEditing ? <NodeInput node={node} /> : <>
                    <Icon className={styles.icon} />
                    <span className={styles.text}>{node.data.name}</span>
                  </>}
              </div>
            </ContextMenuTrigger>
            <ContextMenuContent>
              {editButton()}
              <ContextMenuItem onClick={() => handleAddGroupInsideNode(node)}>
                {t("src_app_dashboard_admin_institutions_id_official_monitor_components_TreeNode_tsx_1")}
              </ContextMenuItem>
              {!node.data.children.length && <ContextMenuItem onClick={() => openRegistratureAddDialog()}>
                  Adaugă Registratură
                </ContextMenuItem>}
              <ContextMenuItem onClick={() => {
          if (node.data.type === "group") {
            return onRemoveFolder(node);
          }
        }}>
                {t("src_app_dashboard_admin_institutions_id_official_monitor_components_TreeNode_tsx_2")}
              </ContextMenuItem>
            </ContextMenuContent>
          </ContextMenu> : <ContextMenu>
            <ContextMenuTrigger>
              <div ref={dragHandle} style={style} className={clsx(styles.node, node.state)} onClick={() => node.isInternal && node.toggle()}>
                <div className={styles.indentLines}>
                  {new Array(indentSize / INDENT_STEP).fill(0).map((_, index) => {
              return <div key={index}></div>;
            })}
                </div>
                <FolderArrow node={node} />
                {node.isEditing ? <NodeInput node={node} /> : <>
                    <Icon className={styles.icon} />
                    <span className={styles.text}>{node.data.name}</span>
                  </>}
              </div>
            </ContextMenuTrigger>
            <ContextMenuContent>
              <ContextMenuItem onClick={() => {
          if (node.data.registratureId) {
            window.open(`/dashboard/registrature/view/${node.data.registratureId}`);
          }
        }}>
                View Registrature
              </ContextMenuItem>
              <ContextMenuItem onClick={() => onRemoveFolder(node)}>
                Delete Registrature
              </ContextMenuItem>
              {editButton()}
            </ContextMenuContent>
          </ContextMenu>}
      </>;
};
function NodeInput({
  node
}: {
  node: NodeApi<Data>;
}) {
  return <Input autoFocus name="name" type="text" defaultValue={node.data.name} onFocus={e => e.currentTarget.select()} onKeyDown={e => {
    if (e.key === "Escape") node.reset();
    if (e.key === "Enter") node.submit(e.currentTarget.value);
  }} data-sentry-element="Input" data-sentry-component="NodeInput" data-sentry-source-file="TreeNode.tsx" />;
}
function FolderArrow({
  node
}: {
  node: NodeApi<Data>;
}) {
  return <span className={styles.arrow} data-sentry-component="FolderArrow" data-sentry-source-file="TreeNode.tsx">
      {node.data.type === "group" ? node.isOpen ? <ArrowUp /> : <ArrowRight /> : null}
    </span>;
}
export default Node;